import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderDialogComponent } from './shared/components/loader-dialog/loader-dialog.component';
import { Toast } from 'primeng/toast';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    LoaderDialogComponent,
    Toast
  ]
})
export class AppComponent {
  title = 'ATS App Core';
}
